import React from 'react';
import GxList from '../../gx/GxList';
import { useTranslation } from '../../hx/useTranslation';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxTable from '../../fx/FxTable';
import { useNav } from '../../hx/useNav';
import { useWindowSize } from '../../hx/useWindowSize';
import { clearStore, StoreClient, StoreRxClenFit } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import GxDlgSelectClient from '../../gx/GxDlgSelectClient';
import GxIconButtonLastClient from '../../gx/GxIconButtonLastClient';


const MxActivityOptiF = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo }] = useNav();

  const size = useWindowSize();
  const [storeClient, setStoreClient] = useSessionStorage('StoreClient', StoreClient);
  const [storeRxClenFit, setStoreRxClenFit] = useSessionStorage('StoreRxClenFit', StoreRxClenFit);
  
  const r_list = React.useRef(null);
  const r_dlg_select_client = React.useRef(null);

  const hasColumnBranchId = () => { return Boolean(localStorage.getItem('MxActivityOptiF.addcol_txBranchId') === '1') };

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  React.useEffect(() => {
    clearStore('StoreRxClenFit', storeRxClenFit);
    // eslint-disable-next-line
  }, []);

  const openForm = async (op, row) => {
    if (row === null) {
      r_dlg_select_client.current.setIntermediateValues({});
      r_dlg_select_client.current.setOpen(true);
    } else {
      FxLog.infox('MxActivityOptiF.openForm', '...row:', row);
      storeClient.inClient = row.original.inClient;
      storeClient.txClient = row.original.txClient;
      Promise.all([setStoreClient(storeClient)]).then((result) => {
        FxLog.infox('MxActivityOptiF.openForm', '...storeClient:', storeClient);
        storeRxClenFit.inRxClenFit = row.original._id;
        setStoreRxClenFit(storeRxClenFit);
        navTo("client-rx-clen-fit-form");
      });
    }
  }

  const getTableColumns = () => {
    let cols = [];
    let id = -1;
    try{
    cols.push({ id: id++, Header: "ID", accessor: "_id", show: false });
    cols.push({ id: "inClient", Header: "inClient", accessor: "inClient", show: false });
    cols.push({ id: "txBranchId", Header: trans('field.branch_id'), accessor: "txBranchId", highlight: true, width: '5%', show: hasColumnBranchId() });
    cols.push({ id: id++, Header: trans('field.client'), accessor: "txClient", highlight: true, width: '20%' });
    cols.push({ id: id++, Header: trans('field.date'), accessor: "dtFrom", highlightDate: true, width: '10%' });

    if (size.isLarge) { // PANTALLA GRANDE
      cols.push({ id: id++, Header: trans('field.reason'), accessor: "txReason", highlight: true, width: '30%' });
      cols.push({ id: id++, Header: trans('field.status'), accessor: row => row["txTypeStatusRx"], width: '15%' });
      cols.push({ id: id++, Header: trans('field.hs_use'), accessor: row => (FxTable.cellTo2r00(row["nuHsUse"])), width: '15%' });

    } else { // PANTALLA PEQUEÑA
    }
    
    cols.push({ id: "G", Header: "finished", accessor: row => Boolean(row["itStatusRx"] === '000002.SRV'), show: false });
    cols.push({ id: "B", Header: "delivered", accessor: row => Boolean(row["itStatusRx"] === '000003.SRV'), show: false });
    return cols;

    } catch(error) {
      FxLog.errorx('MxActivityOptiF.getTableColumns', error)
    }
    return cols;
  }

  const getTooltip = () => {
    let tip = `${trans('field.client')} / ${trans('field.date')} / ${trans('field.reason')}`;
    if (hasColumnBranchId()) tip = tip + `${' / ' + trans('field.branch_id')}`;
    return tip;
  }

  const getTableOptionalCols = () => {
    let cols = [];
    cols.push({ id: 'txBranchId', name: trans('field.branch_id') + " +🔍︎", checked: hasColumnBranchId() ? '1' : '0' });
    return cols;
  }

  const optionsSelected = (options) => {
    localStorage.setItem('MxActivityOptiF.addcol_txBranchId', options.includes('txBranchId') ? '1' : '0');
    r_list.current.getTable().setTooltipText(getTooltip());
    r_list.current.getTable().clearSearch();
    forceUIUpdate();
  }

  return (
    <div>
      <GxList
        moduleName={`${trans('field.activity')}: ${trans('field.rx_clen_fit')}`}
        xref={r_list}
        tooltip={`${trans('field.client')} / ${trans('field.date')} / ${trans('field.reason')}`}
        fullscreen
        url={`activity/opti/typelist/f`}
        onOpenForm={openForm}
        refColors={[
          'table_cell_color_black|' + trans('field.pending'),
          'table_cell_color_green|' + trans('field.finished_1'),
          'table_cell_color_blue|' + trans('field.delivered_1'),
        ]}
        columns={getTableColumns()}
        optionalColumns={getTableOptionalCols()}
        onOptions={optionsSelected}
        optionalFromTo={true}
        optionalFromToButtonToday={true}
        optionalFromToButtonLast7Days={true}
        optionalFromToButtonLast30Days={true}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <GxIconButtonLastClient theList={r_list} />
          </div>
        }
        speechExternal
      />

      <GxDlgSelectClient xref={r_dlg_select_client} 
        includeAnimal={true}
        onSelect={(row, intermediateValues) => {
          FxLog.infox('MxActivityOptiF.return.GxDlgSelectClient', '...row:', row);
          Promise.all([setStoreClient(storeClient)]).then((result) => {
            openForm(null, row);
          });
        }} 
      />

    </div>
  );

}

export default MxActivityOptiF;